import info from './info/ru';

const ru = {
  meta: {
    homeTitle: 'Blissful Play — коллекция Bears | Интимные мармеладки для пар',
    homeDescription: 'Знакомьтесь — Bears: премиальные интимные мармеладки, шоколад и мёд для пар. Анонимная упаковка, быстрая доставка по ЕС. Только 18+.',
    shopTitle: 'Весь каталог — Blissful Play',
    categoryTitle: '{{name}} — Blissful Play',
    categoryDescription: '{{name}} в Blissful Play: премиальные интимные товары для пар, анонимная упаковка, быстрая доставка по ЕС. Только 18+.',
    productTitle: '{{name}} — Blissful Play',
    infoTitle: '{{name}} — Blissful Play',
  },
  lang: {
    label: 'Язык',
    short: { en: 'EN', ru: 'RU', it: 'IT' },
    name: { en: 'English', ru: 'Русский', it: 'Italiano' },
  },
  nav: {
    strip: 'Анонимная упаковка в каждом заказе · Быстрая доставка по ЕС · Только 18+',
    bears: 'Bears ✦ Хиты',
    shopAll: 'Весь каталог',
    how: 'Как это работает',
    faq: 'Вопросы',
    cart: 'Корзина',
    categories: 'Категории',
    openMenu: 'Открыть меню',
    closeMenu: 'Закрыть меню',
  },
  age: {
    badgeAdults: 'Только 18+',
    badgeDiscreet: 'Анонимно',
    title: 'Вам уже есть 18?',
    text: 'Чтобы войти на сайт, вы должны быть совершеннолетним.',
    enter: 'Да, войти',
    leave: 'Нет, уйти',
  },
  hero: {
    badgeLimited: 'Лимитированная партия',
    badgeVegan: 'Веганские мармеладки',
    badgeCouples: 'Для пар',
    titleStart: 'Сделайте ночи',
    titleAccent: 'слаще',
  },
  bears: {
    title: 'Коллекция Bears',
    perkShipping: 'Экспресс-доставка',
    perkPackaging: 'Нейтральная упаковка',
    perkIngredients: 'Премиальный состав',
    prev: 'Предыдущие товары',
    next: 'Следующие товары',
  },
  showcase: {
    title: 'Почему пары выбирают Bears',
    subtitle: 'Натуральные экстракты, сладкий формат и полная анонимность.',
    open: 'Открыть в полном размере',
    alt: {
      couple: 'Мармеладки Boner Bears для мужчин и Bliss Bears для женщин рядом с улыбающейся парой',
      ingredients: 'Состав: экстракт граната, экстракт кошачьего когтя, ашваганда и тонгкат али, экстракт горянки (horny goat weed), L-аргинин',
      chocolateHoney: 'Шоколад и мёд Boner Bears в порционных стиках — просто, удобно и незаметно',
      benefits: 'Главные преимущества: ярче ощущения, быстрое действие, безопасный состав, удобно и анонимно',
      confidence: 'Пара с упаковками мармеладок Boner Bears и Bliss Bears',
    },
  },
  categories: {
    title: 'Выберите коллекцию',
    subtitle: 'Подборка для самых разных удовольствий.',
    count_one: '{{count}} товар',
    count_few: '{{count}} товара',
    count_many: '{{count}} товаров',
    count_other: '{{count}} товара',
  },
  categoryNames: {
    vibrators: 'Вибраторы',
    'cock-rings': 'Эрекционные кольца',
    'enhancement-gummies': 'Мармеладки для либидо',
    'honey-chocolate': 'Мёд и шоколад',
    'adult-toys': 'Игрушки для взрослых',
  },
  how: {
    title: 'Просто. Анонимно. Эффективно.',
    steps: [
      { title: 'Выберите набор', description: 'Загляните в нашу подборку премиальных интимных товаров.' },
      { title: 'Наслаждайтесь моментом', description: 'Разделите впечатления с партнёром.' },
      { title: 'Почувствуйте искру', description: 'Пусть магия случится сама собой.' },
    ],
  },
  reviews: {
    title: 'Пары любят Bears',
    stars: '5 из 5 звёзд',
    items: [
      { name: 'Sarah M.', text: 'Это потрясающе! У нас с партнёром был самый удивительный вечер. Качество на высоте, а эффект именно такой, как обещали. Очень рекомендую!' },
      { name: 'James R.', text: 'Анонимная упаковка — идеально. Сам продукт превзошёл наши ожидания. Обязательно закажем ещё!' },
      { name: 'Emily K.', text: 'Для нас это настоящее открытие. Отличный вкус и незабываемые впечатления. Пять звёзд без вопросов!' },
    ],
  },
  privacy: {
    title: 'Ваша приватность — наш приоритет',
    text: 'Простые коробки без маркировки и указания содержимого. Нейтральное название компании в выписке. Мы никому не передаём ваши данные.',
    packaging: 'Нейтральная упаковка',
    billing: 'Анонимная оплата',
  },
  faq: {
    title: 'Вопросы?',
    items: [
      { question: 'Товары только для 18+?', answer: 'Да. Товары Blissful Play предназначены исключительно для лиц старше 18 лет. Мы проверяем возраст при входе на сайт.' },
      { question: 'Доставка действительно анонимная?', answer: 'Да! Все заказы отправляются в простой упаковке без маркировки и указания содержимого. В банковской выписке будет нейтральное название компании.' },
      { question: 'Сколько идёт доставка?', answer: 'Все заказы отправляются экспресс-доставкой. Обычно посылка приходит за 3–5 рабочих дней. Срочную доставку можно выбрать при оформлении.' },
      { question: 'Это безопасно?', answer: 'Да. Все товары Blissful Play сделаны из премиальных, тщательно отобранных ингредиентов. Каждая партия проходит проверку качества и безопасности.' },
      { question: 'Остались вопросы?', answer: 'Напишите в нашу службу поддержки — мы с радостью ответим на любые вопросы.' },
    ],
  },
  shop: {
    title: 'Все товары',
    subtitle: 'Откройте нашу премиальную коллекцию',
    all: 'Все',
    productsCount_one: '{{count}} товар',
    productsCount_few: '{{count}} товара',
    productsCount_many: '{{count}} товаров',
    productsCount_other: '{{count}} товара',
    empty: 'В этой категории пока нет товаров.',
    viewAll: 'Смотреть все товары',
    loading: 'Загружаем товары…',
    loadFailed: 'Не удалось загрузить товары',
  },
  product: {
    addToCart: 'В корзину',
    added: 'Добавлено',
    addedLive: '{{name}} — добавлено в корзину',
    soldOut: 'Нет в наличии',
    limited: 'Limited',
  },
  pdp: {
    back: 'Назад в каталог',
    loading: 'Загружаем товар…',
    notFound: 'Товар не найден',
    loadFailed: 'Не удалось загрузить товар',
    view: 'вид {{n}}',
    fastDelivery: 'Быстрая доставка',
    fastDeliveryNote: 'ЕС: 5–12 дней',
    discreet: 'Анонимно',
    plainPackaging: 'Нейтральная упаковка',
    size: 'Вариант',
    variantSoldOut: 'Вариант «{{size}}» закончился. Выберите другой или загляните позже.',
    variantLowStock: 'Осталось всего {{count}} шт. варианта «{{size}}» — успейте заказать',
    variantSoldOutToast: 'Извините, этот вариант закончился',
    details: 'О товаре',
    category: 'Категория',
    stock: 'Наличие',
    inStock: 'В наличии',
    onlyLeft: 'Осталось {{count}} шт.',
    delivery: 'Доставка',
    adultsOnly: 'Только для взрослых',
    adultsOnlyText: 'Предназначено для лиц старше 18 лет. Храните в недоступном для детей месте.',
    addToCartPrice: 'В корзину — {{price}}',
    secureCheckout: 'Безопасная оплата',
    privateShipping: 'Анонимная доставка',
  },
  cart: {
    title: 'Корзина',
    empty: 'Ваша корзина пуста',
    total: 'Итого',
    checkout: 'Оформить заказ',
    continue: 'Продолжить покупки',
    close: 'Закрыть корзину',
    size: 'Вариант',
    increase: 'Увеличить количество',
    decrease: 'Уменьшить количество',
    remove: 'Удалить',
    removed: 'Удалено из корзины',
  },
  checkout: {
    stepShipping: 'Доставка',
    stepPayment: 'Оплата',
    shippingTitle: 'Данные доставки',
    shippingSubtitle: 'Укажите, куда доставить заказ',
    firstName: 'Имя',
    lastName: 'Фамилия',
    email: 'Email',
    phone: 'Телефон',
    street: 'Улица и дом',
    apartment: 'Квартира / офис',
    optional: '(необязательно)',
    city: 'Город',
    postalCode: 'Почтовый индекс',
    country: 'Страна',
    required: 'Поле «{{field}}» обязательно',
    emailInvalid: 'Некорректный email',
    fillRequired: 'Пожалуйста, заполните все обязательные поля',
    discreetTitle: 'Анонимная доставка. Без логотипов на упаковке.',
    discreetText: 'Посылка придёт в простой упаковке без маркировки и указания содержимого.',
    continueToPayment: 'Перейти к оплате',
    reviewTitle: 'Проверка и оплата',
    reviewSubtitle: 'Проверьте данные заказа',
    shippingAddress: 'Адрес доставки',
    edit: 'Изменить',
    paymentMethod: 'Способ оплаты',
    stripeRedirect: 'Для завершения покупки вы перейдёте на защищённую страницу оплаты Stripe.',
    securedByStripe: 'Безопасная оплата через Stripe',
    processing: 'Обрабатываем…',
    pay: 'Оплатить {{price}}',
    sessionFailed: 'Не удалось перейти к оплате',
    cartEmpty: 'Ваша корзина пуста',
    continueShopping: 'Продолжить покупки',
    orderSummary: 'Ваш заказ',
    qty: 'Кол-во: {{count}}',
    subtotal: 'Товары',
    shipping: 'Доставка',
    free: 'БЕСПЛАТНО',
    total: 'Итого',
  },
  success: {
    confirming: 'Подтверждаем оплату…',
    title: 'Заказ оформлен!',
    text: 'Спасибо за покупку. Мы получили ваш заказ и отправим его анонимно.',
    orderNumber: 'Номер заказа:',
    emailTitle: 'Письмо с подтверждением отправлено',
    emailText: 'Мы отправили письмо на <1>{{email}}</1> с деталями заказа и информацией для отслеживания.',
    shippingAddress: 'Адрес доставки',
    estimatedDelivery: 'Ожидаемая доставка',
    deliveryText: 'Заказ будет отправлен в течение 24 часов и обычно приходит за 3–5 рабочих дней.',
    discreetTitle: 'Анонимная доставка. Без логотипов на упаковке.',
    discreetText: 'Посылка придёт в простой упаковке без маркировки и указания содержимого. В банковской выписке будет нейтральное название компании. Ваша приватность — наш приоритет.',
    orderSummary: 'Ваш заказ',
    totalPaid: 'Оплачено',
    continueShopping: 'Продолжить покупки',
    backHome: 'На главную',
    help: 'Нужна помощь? Напишите нам:',
    statusTitle: 'Статус оплаты',
    statusError: 'Не удалось проверить статус оплаты',
    statusTimeout: 'Время проверки оплаты истекло',
    backToShop: 'Назад в каталог',
  },
  cancel: {
    title: 'Оплата отменена',
    text: 'Вы отменили оплату. Деньги не списаны.',
    retry: 'Попробовать снова',
    continueShopping: 'Продолжить покупки',
  },
  popup: {
    badge: 'Только для подписчиков',
    titleStart: 'Скидка',
    titleAccent: '10%',
    titleEnd: '',
    text: 'Подпишитесь и получайте специальные предложения.',
    emailLabel: 'Email',
    placeholder: 'Ваш email',
    subscribe: 'Подписаться',
    subscribing: 'Подписываем…',
    legal: 'Подписываясь, вы соглашаетесь получать рекламные письма. Отписаться можно в любой момент.',
    close: 'Закрыть',
    noThanks: 'Нет, спасибо',
    success: 'Вы подписаны!',
    error: 'Не удалось подписаться. Попробуйте ещё раз.',
  },
  footer: {
    tagline: 'Премиальные интимные товары для пар. Анонимная доставка. Безупречное качество.',
    shop: 'Магазин',
    allProducts: 'Все товары',
    bundles: 'Наборы',
    information: 'Информация',
    adults: 'Только для взрослых 18+.',
    cookies: 'Настройки cookie',
  },
  cookies: {
    title: 'Cookie — без лишнего',
    text: 'Мы используем только то, что нужно для работы магазина (корзина, проверка возраста, язык). С вашего согласия — ещё аналитику и маркетинговые cookie, чтобы улучшать сайт.',
    onlyNecessary: 'Только необходимые',
    acceptAll: 'Принять все',
    customize: 'Настроить',
    save: 'Сохранить выбор',
    necessary: 'Необходимые',
    necessaryDesc: 'Корзина, подтверждение возраста и язык. Всегда включены.',
    analytics: 'Аналитика',
    analyticsDesc: 'Анонимная статистика, помогающая улучшать магазин.',
    marketing: 'Маркетинг',
    marketingDesc: 'Оценка рекламы и релевантные предложения.',
  },
  info,
};

export default ru;
